import pagingWithFilteredResults from '@/constants/states';
import { readStates, saveStates } from '@/constants/lifecycle';
import { cohortPermissions } from '../../constants';
import { cohortPermissionGroupNames } from '../constants';
import { findCohort } from '../../state/shared';

export const cohortPerms = (can = false) => {
  const permissions = {};
  Object.values(cohortPermissions).forEach((permission) => {
    permissions[permission] = can;
  });
  return permissions;
};

export const cohortPermsFromArray = (truePermissions = []) => {
  const permissions = cohortPerms();

  truePermissions.forEach((permission) => {
    permissions[permission] = true;
  });

  return permissions;
};

export const newCohortMember = (member, permissions) => (
  {
    ...member,
    permissions: { ...permissions },
    selected: false,
  }
);

export const cohortMembers = (pageSize = 20, minFilterLength = 0, requiresFilter = false) => (
  {
    ...pagingWithFilteredResults(pageSize, minFilterLength, requiresFilter),
    original: [],
    ...readStates,
  }
);

const sharingCohort = () => ({
  open: false,
  code: '',
  category: '',
  permissionGroup: cohortPermissionGroupNames.OBSERVER,
  membersToAdd: [],
  ...saveStates,
});

export const findCohortMembers = (draft, action) => {
  const { unassignedMembers, members } = findCohort(draft, action);
  return action.assignable ? unassignedMembers : members;
};

export default sharingCohort;
